import {Subject} from 'rxjs';

import {InjectionToken, Injector} from '@angular/core';
import {signalExt, WritableSignalExt} from '@shared/signals-extension';

type GlobalDialogControllers = {
	/** The visibility of the dialog */
	visible$: WritableSignalExt<boolean>;
	/** Close the dialog */
	close$: Subject<void>;
};

/**
 * The global dialog controllers
 * @note: this token is used to provide the global dialog controllers
 *
 * @example
 * ```ts
 * const globalDialogControllers = inject(GLOBAL_DIALOG_CONTROLLERS);
 * globalDialogControllers.visible$.set(true);
 * globalDialogControllers.close$.next();
 * ```
 */
export const GLOBAL_DIALOG_CONTROLLERS = new InjectionToken<GlobalDialogControllers>('GLOBAL_DIALOG_CONTROLLERS');

// Factory function to generate the dynamic object
export function GLOBAL_DIALOG_CONTROLLERS_Factory(injector: Injector): GlobalDialogControllers {
	return {
		visible$: signalExt(false, {injector}),
		close$: new Subject<void>(),
	};
}
